import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')

const ViewStaffCrudForms = () => import('./staff/crudForms')
const ViewStaffDetailForms = () => import('./staff/detailForms')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'FormsStaffDashboard',
  crudForms: 'FormsStaffCrudForms',
  detailForms: 'FormsStaffDetailForms',
}

const router =
  [
    {
      path: '/st/forms',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Formularios',
          }                
        },  
        {
          path: 'forms',
          name: VIEWS.crudForms,
          component: ViewStaffCrudForms,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de Formularios',
          }
        },  
        {
          path: 'details',
          name: VIEWS.detailForms,                 
          component: ViewStaffDetailForms,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cosultas Recibidas',
          }
        },                        
      ]
    },

    {
      path: '/cu/forms',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/forms',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
